import { useMemo } from 'react'
import { useQuery, useQueryClient, QueryClient } from 'react-query'
import { useVvsFarmBoostContract } from 'hooks/useContract'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { QueryKey } from 'config/constants/queryKey'
import { VvsFarmBoost } from '../../../types/ethers-contracts'

import {
  queryKeyGetBoostedFarms,
  queryGetBoostedFarms,
  getFarmUserInfoQueryFn,
  getFarmUserInfoQueryKey,
  BoostedFarmUserInfo,
} from './useFarmBoostContract'

export const queryKeyBoostedFarmUserInfos = (account: string) => [QueryKey.BOOSTED_FARM_USERINFOS, account]
export const queryBoostedFarmUserInfos = async (
  queryClient: QueryClient,
  vvsFarmBoostContract: VvsFarmBoost,
  account: string,
) => {
  const boostFarmIds = await queryClient.fetchQuery(queryKeyGetBoostedFarms(account), () =>
    queryGetBoostedFarms(vvsFarmBoostContract, account),
  )
  return Promise.all(
    (boostFarmIds ?? []).map((farmId) =>
      queryClient.fetchQuery(getFarmUserInfoQueryKey(account, farmId), () =>
        getFarmUserInfoQueryFn(farmId, account, vvsFarmBoostContract),
      ),
    ),
  )
}
export const useBoostedFarmUserInfos = () => {
  const { account } = useActiveWeb3React()
  const queryClient = useQueryClient()
  const vvsFarmBoostContract = useVvsFarmBoostContract()

  return useQuery(queryKeyBoostedFarmUserInfos(account), () =>
    queryBoostedFarmUserInfos(queryClient, vvsFarmBoostContract, account),
  )
}

export const boostedFarmIdToUserInfosMap = (data: BoostedFarmUserInfo[]) => {
  return data ? Object.fromEntries(data.map((farmUserInfo) => [farmUserInfo.farmId, farmUserInfo.userInfo])) : undefined
}
export const useBoostedFarmIdToUserInfosMap = () => {
  const { data, ...rest } = useBoostedFarmUserInfos()
  return {
    data: useMemo(() => boostedFarmIdToUserInfosMap(data), [data]),
    ...rest,
  }
}
